import _ from 'lodash';
import React, { useState, Fragment, useEffect } from 'react';
import Image from 'next/image';
import Modal from 'react-modal';
import classnames from 'classnames';

import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';

import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { Menu, Transition } from '@headlessui/react';
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/react';

import api from 'utils/api';
import districts from 'utils/districts';

import { useAppLaunch } from 'contexts/AppLaunch';
import { useUserAuth } from 'contexts/UserAuth';

import classNames from 'classnames';
// import { firebaseAuth } from 'utils/firebaseConfig';
// import { httpCall } from 'functions/httpAction';

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISH_KEY);

const RedeemModal = (props) => {
  const {
    isShow,
    setIsShow,
    currentCampaignRewards,
    currentCampaign,
    currentSorraUserM2mProgramRewards,
    currentSorraUserM2mProgram,
    unpaidRedeem,
    mutateMissions,
    defaultReward = '',
  } = props;
  const { campaignMap } = useAppLaunch();
  const { getAuthorizationHeader } = useUserAuth();

  // const campaign = campaignMap[currentCampaign];
  const hasShippingFee = true; //_.get(campaign, 'shipping_fee') === true;
  // const [stripeClientSecret, setStripeClientSecret] = useState('');
  const [paymentRedeemId, setPaymentRedeemId] = useState(null);
  const [isStripeComplete, setIsStripeComplete] = useState(false);

  const districtList = _.keys(districts);
  const [district, setDistrict] = useState(null);
  const [subDistrict, setSubDistrict] = useState(null);
  // const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  // console.log({ campaign: campaignMap[currentCampaign] });
  // console.log({ campaign, hasShippingFee });

  const rewards =
    currentCampaignRewards || currentSorraUserM2mProgramRewards || [];
  // const defaultReward
  // swapping rewards
  const defaultRewardItem = defaultReward
    ? rewards.find((item) => item.name == defaultReward)
    : null;

  const [selectedItemTitle, setSelectedItemTitle] = useState(
    defaultRewardItem ? defaultRewardItem.name : ''
  );
  const [selectedItemId, setSelectedItemId] = useState(
    defaultRewardItem ? defaultRewardItem.id : null
  );

  const selectedReward = rewards.find((item) => item.id == selectedItemId);

  const [receiverName, setReceiverName] = useState('');
  const [receiverPhone, setReceiverPhone] = useState('');
  const [receiverAddress, setReceiverAddress] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  // general
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const isFormFilled =
    !_.isNil(setSelectedItemId) &&
    receiverName &&
    receiverPhone &&
    receiverAddress &&
    district &&
    subDistrict;

  const passRewards = async () => {
    // const auth = firebaseAuth;
    // const user = auth.currentUser;
    // const token = user.accessToken;

    // const targetItem = rewards.find((item) => item.name == selectedItemTitle);
    const targetItemId = selectedItemId; //targetItem.id;

    const passObject = {
      reward: targetItemId,
      campaign: currentCampaign,
      sorra_user_m2m_program: currentSorraUserM2mProgram,
      receiver: receiverName,
      phone: receiverPhone,
      address: receiverAddress,
      district: district,
      sub_district: subDistrict,
    };

    setIsLoading(true);

    try {
      const headers = await getAuthorizationHeader();
      const { data } = await api.request({
        method: 'POST',
        url: currentCampaign
          ? '/api/v2/me/campaignRedeem'
          : '/api/v3/me/m2mRedeem',
        headers,
        data: passObject,
      });
      // const [success, error, statusCode, data] = await httpCall(
      //   'post',
      //   process.env.NEXT_PUBLIC_API_HOST + '/api/v2/me/campaignRedeem',
      //   token,
      //   passObject
      // );
      if (data.stripe_client_secret) {
        setPaymentRedeemId(data.redeem);
        // setStripeClientSecret(data.stripe_client_secret);
      } else {
        setIsFormSubmitted(true);
      }
      setIsLoading(false);

      // if (success) {
      //   setIsLoading(false);

      //   if (statusCode == 200) {
      //     if (data.stripe_client_secret) {
      //       setPaymentRedeemId(data.redeem);
      //       // setStripeClientSecret(data.stripe_client_secret);
      //     } else {
      //       setIsFormSubmitted(true);
      //     }
      //   } else {
      //     setIsError(true);
      //     if (data.message == 'Redeemed already') {
      //       setErrorMsg('無法重複換領。');
      //     } else {
      //       setErrorMsg('');
      //     }
      //   }
      // }

      // setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsError(true);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message == 'Redeemed already'
      ) {
        setErrorMsg('無法重複換領。');
      } else if (error.response && error.response.data) {
        setErrorMsg(error.response.data.message);
      } else {
        setErrorMsg('');
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsError(false);
    setErrorMsg('');
  }, [selectedItemTitle, receiverAddress, receiverName, receiverPhone]);

  const links = [
    { href: '/settings', label: 'Settings' },
    { href: '/support', label: 'Support' },
    { href: '/license', label: 'License' },
  ];

  if (!isShow) return null;

  return (
    <>
      <div
        className="register-popupbg hidden lg:flex"
        onClick={() => setIsShow(false)}
      >
        <div
          className="register-popup flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="relative mx-[16px] mt-[16px] flex h-[48px] flex-row items-center justify-between">
            <div className="flex items-center justify-center">
              <div
                className="absolute left-0 top-0 flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-[8px] border-[1px] border-[#E7E7E7]"
                onClick={() => setIsShow(false)}
              >
                <Image src="/svgs/close.svg" alt="" width={30} height={30} />
              </div>
            </div>
            <div className="flex flex-col items-center justify-center">
              <div className="text-[18px] font-[500]">
                {currentCampaign ? '換領迎新禮' : '換領禮品'}
              </div>
            </div>
            <div />
          </div>
          <div className="mx-[16px] my-[24px] flex grow flex-col items-start justify-between space-y-4">
            {!isFormSubmitted ? (
              <div className="w-full">
                <div className="text-start text-xl font-bold">換領資料</div>
                <div className="mt-6 space-y-2">
                  <div className="text-base font-medium">
                    {currentCampaign ? '迎新禮' : '禮品'}選擇
                  </div>
                  <div className="w-full">
                    <Menu as={Fragment}>
                      {({ open, close }) => {
                        const selectedBrandName =
                          _.get(selectedReward, 'brand.name') || '';
                        const selectedDisplayName = `${selectedBrandName ? `${selectedBrandName} ` : ''}${selectedReward ? selectedReward.name : ''}`;
                        return (
                          <>
                            <span className="rounded-md shadow-sm">
                              <Menu.Button className="focus:shadow-outline-blue inline-flex w-full justify-between rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium leading-5 text-black transition duration-150 ease-in-out hover:text-gray-500 focus:border-blue-300 focus:outline-none active:bg-gray-50 active:text-gray-800">
                                <span className="truncate text-start">
                                  {selectedDisplayName}
                                </span>
                                <svg
                                  className="-mr-1 ml-2 h-5 w-5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </Menu.Button>
                            </span>

                            <Transition
                              as={Fragment}
                              show={open}
                              enter="transition ease-out duration-100"
                              enterFrom="transform opacity-0 scale-0"
                              enterTo="transform opacity-100 scale-100"
                              leave="transition ease-in duration-75"
                              leaveFrom="transform opacity-100 scale-100"
                              leaveTo="transform opacity-0 scale-0"
                            >
                              <Menu.Items
                                static
                                className="absolute left-4 mt-2 w-[calc(100%-32px)] origin-top-right divide-y divide-gray-100 rounded-md border border-gray-200 bg-white shadow-lg outline-none"
                              >
                                <div className="space-y-3 px-4 py-2">
                                  {rewards.map((item, index) => {
                                    const brandName =
                                      _.get(item, 'brand.name') || '';
                                    const displayName = `${brandName ? `${brandName} ` : ''}${item.name}`;
                                    return (
                                      <Menu.Item
                                        key={item.name}
                                        className={({ active, disabled }) =>
                                          `relative select-none ${active ? 'bg-sorra-pink text-white' : 'text-gray-900'} ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`
                                        }
                                        value={item.name}
                                        disabled={item.inventory == 0}
                                      >
                                        {({ selected, active, disabled }) => (
                                          <>
                                            <span
                                              className={`block truncate ${!disabled ? 'cursor-pointer text-black' : 'cursor-not-allowed text-gray-300'} ${
                                                selected
                                                  ? 'font-medium'
                                                  : 'font-normal'
                                              }`}
                                              onClick={() => {
                                                if (!disabled) {
                                                  setSelectedItemId(item.id);
                                                  setSelectedItemTitle(
                                                    item.name
                                                  );
                                                  close();
                                                }
                                              }}
                                            >
                                              {`${item.inventory == 0 ? '【已換完】' : ''}${displayName}`}
                                            </span>
                                          </>
                                        )}
                                      </Menu.Item>
                                    );
                                  })}
                                </div>
                              </Menu.Items>
                            </Transition>
                          </>
                        );
                      }}
                    </Menu>
                  </div>
                </div>
                <div className="mt-5 space-y-2">
                  <div className="text-base font-medium">收件人</div>
                  <div className="h-[48px] w-[100%] rounded-[8px] border-[1px] border-[#E7E7E7]">
                    <input
                      className="h-[100%] w-[100%] rounded-[8px] border-none px-[8px] focus:ring-0"
                      value={receiverName}
                      type="text"
                      placeholder="收件人姓名"
                      onChange={(e) => {
                        setReceiverName(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="mt-5 space-y-2">
                  <div className="text-base font-medium">收件人電話 (+852)</div>
                  <div className="h-[48px] w-[100%] rounded-[8px] border-[1px] border-[#E7E7E7]">
                    <input
                      className="h-[100%] w-[100%] rounded-[8px] border-none px-[8px] focus:ring-0"
                      value={receiverPhone}
                      type="text"
                      placeholder="99998888"
                      onChange={(e) => {
                        setReceiverPhone(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="mt-5 space-y-2">
                  <div className="text-base font-medium">派送地區</div>
                  <Listbox
                    value={district}
                    onChange={(v) => {
                      setDistrict(v);
                      setSubDistrict(null);
                    }}
                    // disabled={true}
                  >
                    <div className="relative mt-2">
                      <ListboxButton className="relative h-12 w-full cursor-default rounded-lg border border-[#E7E7E7] bg-white px-2 text-left">
                        <span
                          className={classnames('block truncate', {
                            'text-gray-500': !district,
                          })}
                        >
                          {district || '派送地區'}
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                          <ChevronUpDownIcon
                            aria-hidden="true"
                            className="h-5 w-5 text-gray-400"
                          />
                        </span>
                      </ListboxButton>
                      <ListboxOptions
                        transition
                        className="sm:text-sm absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
                      >
                        {districtList.map((d, idx) => (
                          <ListboxOption
                            key={d}
                            value={d}
                            className="group relative cursor-pointer py-2 pl-3 pr-9"
                          >
                            <span className="block truncate">{d}</span>
                          </ListboxOption>
                        ))}
                      </ListboxOptions>
                    </div>
                  </Listbox>
                </div>
                <div className="mt-5 space-y-2">
                  <div className="text-base font-medium">派送區域</div>
                  <Listbox
                    value={subDistrict}
                    onChange={setSubDistrict}
                    disabled={!district}
                  >
                    <div className="relative mt-2">
                      <ListboxButton className="relative h-12 w-full cursor-default rounded-lg border border-[#E7E7E7] bg-white px-2 text-left">
                        <span
                          className={classnames('block truncate', {
                            'text-gray-500': !subDistrict,
                            'cursor-not-allowed': !district,
                          })}
                        >
                          {subDistrict || '派送區域'}
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                          <ChevronUpDownIcon
                            aria-hidden="true"
                            className="h-5 w-5 text-gray-400"
                          />
                        </span>
                      </ListboxButton>
                      <ListboxOptions
                        transition
                        className="sm:text-sm absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
                      >
                        {(districts[district] || []).map((d, idx) => (
                          <ListboxOption
                            key={d}
                            value={d}
                            className="group relative cursor-pointer py-2 pl-3 pr-9"
                          >
                            <span className="block truncate">{d}</span>
                          </ListboxOption>
                        ))}
                      </ListboxOptions>
                    </div>
                  </Listbox>
                </div>
                <div className="mt-5 space-y-2">
                  {hasShippingFee ? (
                    <div className="text-base font-medium">
                      派送地址（順豐自取點／上門）
                    </div>
                  ) : (
                    <div className="text-base font-medium">
                      <div>平郵地址（免運費）</div>
                      <div>
                        ◎ 請填寫可投遞郵件之
                        <span className="underline">平郵地址</span>
                        ，不可使用郵站。
                      </div>
                      <div>◎ 亦可選擇順豐自取點，以到付形式寄出</div>
                    </div>
                  )}
                  <div className="h-[48px] w-[100%] rounded-[8px] border-[1px] border-[#E7E7E7]">
                    <input
                      className="h-[100%] w-[100%] rounded-[8px] border-none px-[8px] focus:ring-0"
                      value={receiverAddress}
                      type="text"
                      placeholder={
                        hasShippingFee
                          ? '派送地址（順豐自取點／上門）'
                          : '平郵地址'
                      }
                      onChange={(e) => {
                        setReceiverAddress(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {hasShippingFee && (
                  <div className="mt-5 space-y-2">
                    <div className="text-base font-medium">
                      運費（將於下一步收取）
                    </div>
                    <div className="h-[48px] w-[100%] rounded-[8px] border-[1px] border-[#E7E7E7]">
                      <input
                        className="h-[100%] w-[100%] rounded-[8px] border-none px-[8px] focus:ring-0"
                        defaultValue="HKD$30"
                        type="text"
                        disabled
                      />
                    </div>
                  </div>
                )}
                {isError ? (
                  <div className="mt-3 text-[14px] font-[400] text-[#9B1C1C]">
                    <div className="flex flex-row items-center">
                      <Image
                        src="/svgs/error.svg"
                        width={16}
                        height={16}
                        alt=""
                        className="mr-[8px]"
                      />
                      {errorMsg}
                    </div>
                  </div>
                ) : null}
                <div
                  className={classNames('text-sm font-normal text-gray-500', {
                    'mt-1': isError,
                    'mt-4': !isError,
                  })}
                >
                  現時僅限香港用戶參與換領。確認即表示您了解並同意Sorra服務條款及私隱政策
                </div>
              </div>
            ) : (
              <div className="flex h-[510px] w-full flex-col items-center justify-center">
                <img
                  src="/svgs/complete-gift.svg"
                  className="mx-auto h-[128px] w-[128px]"
                />
                <div className="mt-12 text-xl font-bold">迎新禮換領確認</div>
                <div className="mt-2 text-center text-sm font-normal text-[#4A4A4A]">
                  我們將於10～20個工作天內寄送迎新禮到你府上。
                  <br />
                  等待期間，立即做任務賺分換禮物！
                </div>
              </div>
            )}
            {!isFormSubmitted ? (
              <div className="flex w-full flex-row items-center justify-center text-[16px] font-[500]">
                <button
                  className="mr-[16px] h-[48px] w-[163px] rounded-[8px] border-[1px]"
                  onClick={() => setIsShow(false)}
                >
                  返回
                </button>
                <button
                  className={classNames(
                    'h-[48px] w-[163px] rounded-[8px] text-[#fff]',
                    {
                      'bg-sorra-pink': isFormFilled,
                      'bg-sorra-pink-light': isLoading,
                      'bg-sorra-gray-100': !isFormFilled,
                    }
                  )}
                  onClick={isFormFilled ? () => passRewards() : () => {}}
                >
                  下一步
                </button>
              </div>
            ) : (
              <div className="flex w-full items-center justify-center">
                <button
                  className={classNames(
                    'h-[48px] w-[311px] rounded-[8px] bg-sorra-pink text-[#fff]'
                  )}
                  onClick={() => setIsShow(false)}
                >
                  做任務
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="p-safe-offset fixed inset-0 z-[61] block bg-white lg:hidden">
        <div className="relative flex h-full w-full flex-col">
          <div className="flex h-[91px] items-center justify-center pt-9">
            <div
              className="absolute left-4 top-6 flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-[8px] border-[1px] border-[#E7E7E7]"
              onClick={() => setIsShow(false)}
            >
              <Image src="/svgs/close.svg" alt="" width={30} height={30} />
            </div>
            <div className="flex flex-col items-center justify-center">
              <div className="text-[18px] font-[500]">換領迎新禮</div>
            </div>
          </div>
          <div className="flex min-h-0 grow flex-col justify-between overflow-y-scroll px-4 pb-4 pt-7">
            {!isFormSubmitted ? (
              <div className="w-full">
                <div className="text-start text-xl font-bold">換領資料</div>
                <div className="mt-6 space-y-2">
                  <div className="text-base font-medium">迎新禮選擇</div>
                  <div className="relative w-full">
                    <Menu as={Fragment}>
                      {({ open, close }) => (
                        <>
                          <span className="rounded-md shadow-sm">
                            <Menu.Button className="focus:shadow-outline-blue inline-flex w-full justify-between rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium leading-5 text-black transition duration-150 ease-in-out hover:text-gray-500 focus:border-blue-300 focus:outline-none active:bg-gray-50 active:text-gray-800">
                              <span className="truncate text-start">
                                {selectedItemTitle}
                              </span>
                              <svg
                                className="-mr-1 ml-2 h-5 w-5"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </Menu.Button>
                          </span>

                          <Transition
                            as={Fragment}
                            show={open}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-0"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-0"
                          >
                            <Menu.Items
                              static
                              className="absolute mt-2 w-full origin-top-right divide-y divide-gray-100 rounded-md border border-gray-200 bg-white shadow-lg outline-none"
                            >
                              <div className="space-y-3 px-4 py-2">
                                {rewards.map((item, index) => (
                                  <Menu.Item
                                    key={item.name}
                                    className={({ active, disabled }) =>
                                      `relative select-none ${active ? 'bg-sorra-pink text-white' : 'text-gray-900'} ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`
                                    }
                                    value={item.name}
                                    disabled={item.inventory == 0}
                                  >
                                    {({ selected, active, disabled }) => (
                                      <>
                                        <span
                                          className={`block truncate ${!disabled ? 'cursor-pointer text-black' : 'cursor-not-allowed text-gray-300'} ${
                                            selected
                                              ? 'font-medium'
                                              : 'font-normal'
                                          }`}
                                          onClick={() => {
                                            if (!disabled) {
                                              setSelectedItemTitle(item.name);
                                              close();
                                            }
                                          }}
                                        >
                                          {`${item.inventory == 0 ? '【已換完】' : ''}${item.name}`}
                                        </span>
                                      </>
                                    )}
                                  </Menu.Item>
                                ))}
                              </div>
                            </Menu.Items>
                          </Transition>
                        </>
                      )}
                    </Menu>
                  </div>
                </div>
                <div className="mt-5 space-y-2">
                  <div className="text-base font-medium">收件人</div>
                  <div className="h-[48px] w-[100%] rounded-[8px] border-[1px] border-[#E7E7E7]">
                    <input
                      className="h-[100%] w-[100%] rounded-[8px] border-none px-[8px] focus:ring-0"
                      value={receiverName}
                      type="text"
                      placeholder="收件人姓名"
                      onChange={(e) => {
                        setReceiverName(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="mt-5 space-y-2">
                  <div className="text-base font-medium">收件人電話 (+852)</div>
                  <div className="h-[48px] w-[100%] rounded-[8px] border-[1px] border-[#E7E7E7]">
                    <input
                      className="h-[100%] w-[100%] rounded-[8px] border-none px-[8px] focus:ring-0"
                      value={receiverPhone}
                      type="text"
                      placeholder="99998888"
                      onChange={(e) => {
                        setReceiverPhone(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="mt-5 space-y-2">
                  <div className="text-base font-medium">派送地區</div>
                  <Listbox
                    value={district}
                    onChange={(v) => {
                      setDistrict(v);
                      setSubDistrict(null);
                    }}
                    // disabled={true}
                  >
                    <div className="relative mt-2">
                      <ListboxButton className="relative h-12 w-full cursor-default rounded-lg border border-[#E7E7E7] bg-white px-2 text-left">
                        <span
                          className={classnames('block truncate', {
                            'text-gray-500': !district,
                          })}
                        >
                          {district || '派送地區'}
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                          <ChevronUpDownIcon
                            aria-hidden="true"
                            className="h-5 w-5 text-gray-400"
                          />
                        </span>
                      </ListboxButton>
                      <ListboxOptions
                        transition
                        className="sm:text-sm absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
                      >
                        {districtList.map((d, idx) => (
                          <ListboxOption
                            key={d}
                            value={d}
                            className="group relative cursor-pointer py-2 pl-3 pr-9"
                          >
                            <span className="block truncate">{d}</span>
                          </ListboxOption>
                        ))}
                      </ListboxOptions>
                    </div>
                  </Listbox>
                </div>
                <div className="mt-5 space-y-2">
                  <div className="text-base font-medium">派送區域</div>
                  <Listbox
                    value={subDistrict}
                    onChange={setSubDistrict}
                    disabled={!district}
                  >
                    <div className="relative mt-2">
                      <ListboxButton className="relative h-12 w-full cursor-default rounded-lg border border-[#E7E7E7] bg-white px-2 text-left">
                        <span
                          className={classnames('block truncate', {
                            'text-gray-500': !subDistrict,
                            'cursor-not-allowed': !district,
                          })}
                        >
                          {subDistrict || '派送區域'}
                        </span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                          <ChevronUpDownIcon
                            aria-hidden="true"
                            className="h-5 w-5 text-gray-400"
                          />
                        </span>
                      </ListboxButton>
                      <ListboxOptions
                        transition
                        className="sm:text-sm absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in"
                      >
                        {(districts[district] || []).map((d, idx) => (
                          <ListboxOption
                            key={d}
                            value={d}
                            className="group relative cursor-pointer py-2 pl-3 pr-9"
                          >
                            <span className="block truncate">{d}</span>
                          </ListboxOption>
                        ))}
                      </ListboxOptions>
                    </div>
                  </Listbox>
                </div>
                <div className="mt-5 space-y-2">
                  {hasShippingFee ? (
                    <div className="text-base font-medium">
                      派送地址（順豐自取點／上門）
                    </div>
                  ) : (
                    <div className="text-base font-medium">
                      <div>平郵地址（免運費）</div>
                      <div>
                        ◎ 請填寫可投遞郵件之
                        <span className="underline">平郵地址</span>
                        ，不可使用郵站。
                      </div>
                      <div>◎ 亦可選擇順豐自取點，以到付形式寄出</div>
                    </div>
                  )}
                  <div className="h-[48px] w-[100%] rounded-[8px] border-[1px] border-[#E7E7E7]">
                    <input
                      className="h-[100%] w-[100%] rounded-[8px] border-none px-[8px] focus:ring-0"
                      value={receiverAddress}
                      type="text"
                      placeholder={
                        hasShippingFee
                          ? '派送地址（順豐自取點／上門）'
                          : '平郵地址'
                      }
                      onChange={(e) => {
                        setReceiverAddress(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {hasShippingFee && (
                  <div className="mt-5 space-y-2">
                    <div className="text-base font-medium">
                      運費（將於下一步收取）
                    </div>
                    <div className="h-[48px] w-[100%] rounded-[8px] border-[1px] border-[#E7E7E7]">
                      <input
                        className="h-[100%] w-[100%] rounded-[8px] border-none px-[8px] focus:ring-0"
                        defaultValue="HKD$30"
                        type="text"
                        disabled
                      />
                    </div>
                  </div>
                )}
                <div className="mt-4 text-sm font-normal text-gray-500">
                  現時僅限香港用戶參與換領。確認即表示您了解並同意Sorra服務條款及私隱政策
                </div>
                {!isFormSubmitted ? (
                  <div className="mt-4 flex w-full flex-row items-center justify-center text-[16px] font-[500]">
                    <button
                      className="mr-[16px] h-[48px] w-[163px] rounded-[8px] border-[1px]"
                      onClick={() => setIsShow(false)}
                    >
                      返回
                    </button>
                    <button
                      className={classNames(
                        'h-[48px] w-[163px] rounded-[8px] text-[#fff]',
                        {
                          'bg-sorra-pink': isFormFilled,
                          'bg-sorra-pink-light': isLoading,
                          'bg-sorra-gray-100': !isFormFilled,
                        }
                      )}
                      onClick={isFormFilled ? () => passRewards() : () => {}}
                    >
                      下一步
                    </button>
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="flex h-[510px] w-full flex-col items-center justify-center">
                <img
                  src="/svgs/complete-gift.svg"
                  className="mx-auto h-[128px] w-[128px]"
                />
                <div className="mt-12 text-xl font-bold">迎新禮換領確認</div>
                <div className="mt-2 text-center text-sm font-normal text-[#4A4A4A]">
                  我們將於10～20個工作天內寄送迎新禮到你府上。
                  <br />
                  等待期間，立即做任務賺分換禮物！
                </div>
              </div>
            )}
            {isFormSubmitted ? (
              <div className="flex w-full items-center justify-center">
                <button
                  className={classNames(
                    'h-[48px] w-[311px] rounded-[8px] bg-sorra-pink text-[#fff]'
                  )}
                  onClick={() => setIsShow(false)}
                >
                  做任務
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <Modal
        isOpen={
          !isFormSubmitted && (!_.isNil(paymentRedeemId) || unpaidRedeem)
            ? true
            : false
        }
        onRequestClose={() => {
          // setIsApplyModalOpen(false);
        }}
        shouldCloseOnOverlayClick={false}
        className="h-full max-h-none w-full overflow-y-auto rounded-none bg-white px-4 pb-8 pt-3 outline-none lg:pb-10 lg:pt-10"
        overlayClassName="z-[80] absolute flex items-center justify-center top-0 left-0 right-0 bottom-0 w-full h-full bg-[#111928] bg-opacity-50"
      >
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={{
            fetchClientSecret: async () => {
              const targetRedeemId = unpaidRedeem
                ? unpaidRedeem.id
                : paymentRedeemId;
              try {
                const headers = await getAuthorizationHeader();
                const { data } = await api.request({
                  url: `/api/v3/retrieveStripePaymentSession`,
                  method: 'GET',
                  params: {
                    redeemId: targetRedeemId,
                  },
                  headers: {
                    ...headers,
                  },
                });
                const { stripe_client_secret } = data;
                return stripe_client_secret;
              } catch (error) {
                console.log('error', error);
              }
              return null;
            },
            onComplete: () => {
              setIsStripeComplete(true);
              setPaymentRedeemId(null);
              setIsFormSubmitted(true);
              mutateMissions();
            },
          }}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </Modal>
    </>
  );
};

export default RedeemModal;
